import { Key, useState } from 'react';
import { Button } from '@/view/components/ui/button'
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from './ui/table';
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from '@/view/components/ui/dropdown-menu'
import { MoreHorizontal, Eye, UserPen, Trash2 } from 'lucide-react';
import { DialogDetailUnits } from '../modals/modal-detail-units';
import { DialogEditUnits } from '../modals/modal-edit-units';
import { DialogDelete } from '../modals/modal-delete';
import { Endpoints } from '@/remote/endpoints';
import { ScrollArea } from './ui/scroll-area';



type TableUnits = {
  data?: any;
  getRefreshList?: () => void
  height?: string;
}


export function TableUnits({ data, height, getRefreshList }: TableUnits) {

  const [dataId, setDataId] = useState(0)
  const [dialogDetail, setDialogDetail] = useState(false)
  const [dialogEdit, setDialogEdit] = useState(false)
  const [dialogDelete, setDialogDelete] = useState(false)

  const openDialogDetail = (id: number) => {
    setDataId(id)
    setDialogDetail(true)
  }

  const closeDialogDetail = () => {
    setDialogDetail(false)
  }

  const openDialogEdit = (id: number) => {
    setDataId(id)
    setDialogEdit(true)
  }

  const closeDialogEdit = () => {
    setDialogEdit(false)
  }

  const openDialogDelete = (id: number) => {
    setDataId(id)
    setDialogDelete(true)
  }

  const closeDialogDelete = () => {
    setDialogDelete(false)
  }

  return (
    <div className={'overflow-y-auto ' + height}>
      {dialogDetail && <DialogDetailUnits id={dataId} closeDialog={closeDialogDetail} isOpen={dialogDetail} />}
      {dialogEdit && <DialogEditUnits id={dataId} closeDialog={closeDialogEdit} isOpen={dialogEdit} updateList={getRefreshList} />}
      {dialogDelete && <DialogDelete id={dataId} updateList={getRefreshList} closeDialog={closeDialogDelete} isOpen={dialogDelete} url={Endpoints.units} label='Unidades' />}
      <ScrollArea className="m-4 h-container-members-list relative">
      <Table className='border-none'>
        <TableHeader className="">
          <TableRow>
            <TableHead>ID</TableHead>
            <TableHead>Nome Fantasia</TableHead>
            <TableHead>Razão Social</TableHead>
            <TableHead>CNPJ</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody className="">
          {data.map((unidade: any, position: Key | null | undefined) => (
            <TableRow key={position} className="text-gray-600">
              <TableCell className='text-black'>{unidade.id}</TableCell>
              <TableCell className='text-black'>{unidade.nomeFantasia}</TableCell>
              <TableCell className='text-black'>{unidade.razaoSocial}</TableCell>
              <TableCell className='text-black'>{unidade.cnpj}</TableCell>
              <TableCell>
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" className="h-8 w-8 p-0">
                      <span className="sr-only">Abrir Menu</span>
                      <MoreHorizontal className="h-4 w-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="center">
                    <DropdownMenuLabel>Ações</DropdownMenuLabel>
                    <DropdownMenuItem className='flex gap-2 cursor-pointer' onClick={() => openDialogDetail(unidade?.id)}><Eye

                      height={24}
                      width={30}
                      className='text-blue-500 cursor-pointer p-1  hover:text-blue-400' />Detalhes
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem className='flex gap-2 cursor-pointer ' onClick={() => openDialogEdit(unidade?.id)} ><UserPen

                      height={24}
                      width={30}
                      className='text-blue-500 cursor-pointer p-1  hover:text-blue-400' />Editar
                    </DropdownMenuItem>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem className='flex gap-2 cursor-pointer ' onClick={() => openDialogDelete(unidade?.id)}>
                      <Trash2

                        height={24}
                        width={30}
                        className='text-red-500 cursor-pointer p-1  hover:text-red-400' />Apagar
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      </ScrollArea>
    </div>
  );
}
